import { render, staticRenderFns } from "./AdminBlockModal.vue?vue&type=template&id=78ca871e&"
import script from "./AdminBlockModal.vue?vue&type=script&lang=js&"
export * from "./AdminBlockModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports